export interface FlowDashboardProps {}

export const FlowDashboard: React.FC<FlowDashboardProps> = ({}) => {
  return <></>
}
